import React from 'react';

function WaitingSection({ pendingQueue, readerActive, onActivate }) {

  return (
    <section className="waiting-section">
      {!readerActive && (
        <button onClick={onActivate} autoFocus width="100%">
          {readerActive ? 'Sonando' : 'Activar Sonido'}
        </button>
      )}
      <div className="title-card">Cola de espera</div>
      {pendingQueue.map((person, index) => (
        <div key={index} className="queue-item">
          {person.isPreferred ? <span>&#9855;</span> : index + 1}{' '}
          {person.name}
        </div>
      ))}
    </section>
  );
}

export default WaitingSection;
